var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DefaultLayoutVue',[_vm._v(" a ")])
}
var staticRenderFns = []

export { render, staticRenderFns }